import {
    AnyAction,
} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const updateNinchatStateReducer = (state: NinchatState, action: AnyAction) => {
    Object.assign(state, action.payload)
}
